(function () {
  'use strict';

  function hardenExternalLinks() {
    document.querySelectorAll('a').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var target = (link.getAttribute('target') || '').toLowerCase();

      if (target === '_blank') {
        var rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        rel.add('noopener');
        rel.add('noreferrer');
        link.setAttribute('rel', Array.from(rel).join(' '));
      }

      if (/^https?:\/\//i.test(href)) {
        try {
          if (new URL(href, window.location.href).origin !== window.location.origin) {
            link.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
          }
        } catch (error) {}
      }
    });
  }

  function blockUnsafeProtocol(event) {
    var link = event.target && event.target.closest ? event.target.closest('a') : null;
    if (!link) return;

    var href = (link.getAttribute('href') || '').trim().toLowerCase();
    if (href.indexOf('javascript:') === 0 || href.indexOf('data:') === 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function start() {
    hardenExternalLinks();
    document.addEventListener('click', blockUnsafeProtocol, true);
    new MutationObserver(hardenExternalLinks).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
